import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Card,
  CardContent,
  Typography,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

// LAP-733 (GE022): labels resolved via t() at render time
const HORIZON_OPTIONS = [
  { value: 'YEAR_CURRENT', labelKey: 'timeYearCurrent',  descKey: 'timeYearCurrentDesc' },
  { value: 'YEAR_NEXT',    labelKey: 'timeYearNext',     descKey: 'timeYearNextDesc' },
  { value: 'YEAR_5',       labelKey: 'timeYear5',        descKey: 'timeYear5Desc' },
  { value: 'YEAR_10',      labelKey: 'timeYear10',       descKey: 'timeYear10Desc' },
  { value: 'DREAMS',       labelKey: 'timeDreams',       descKey: 'timeDreamsDesc' },
]

const SelectableCard = styled(Card)(({ theme, selected }) => ({
  cursor: 'pointer',
  border: selected
    ? '2px solid #1976d2'
    : '2px solid rgba(255, 255, 255, 0.2)',
  backgroundColor: selected
    ? 'rgba(25, 118, 210, 0.2)'
    : 'rgba(255, 255, 255, 0.05)',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: selected
      ? 'rgba(25, 118, 210, 0.3)'
      : 'rgba(255, 255, 255, 0.1)',
    borderColor: selected ? '#1976d2' : 'rgba(255, 255, 255, 0.4)',
  },
}))

const TimeProjectionPopup = ({ open, onClose, onSubmit, onBack }) => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [selectedHorizon, setSelectedHorizon] = useState(null)

  const handleCardClick = (horizon) => {
    setSelectedHorizon(horizon)
  }

  const handleContinue = () => {
    if (selectedHorizon) {
      onSubmit(selectedHorizon)
    }
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          background: 'rgba(0, 0, 29, 0.95)',
          backdropFilter: 'blur(10px)',
          borderRadius: '16px',
        },
      }}
    >
      <DialogTitle
        sx={{
          color: 'white',
          fontSize: '1.5rem',
          fontWeight: 500,
        }}
      >
        {t('roadmap.timeProjTitle')}
      </DialogTitle>
      <DialogContent
        sx={{
          // Custom scrollbar styling (Word/Google Docs style)
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(255, 255, 255, 0.3)',
            borderRadius: '4px',
            '&:hover': {
              background: 'rgba(255, 255, 255, 0.5)',
            },
          },
          // Firefox scrollbar
          scrollbarWidth: 'thin',
          scrollbarColor: 'rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.05)',
        }}
      >
        <Typography
          variant="body2"
          sx={{ color: 'rgba(255, 255, 255, 0.7)', mb: 3 }}
        >
          {t('roadmap.timeProjHelperFull')}
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {HORIZON_OPTIONS.map((option) => (
            <SelectableCard
              key={option.value}
              selected={selectedHorizon === option.value}
              onClick={() => handleCardClick(option.value)}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{
                    color: 'white',
                    fontWeight: 500,
                    mb: 1,
                  }}
                >
                  {t('roadmap.' + option.labelKey)}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'rgba(255, 255, 255, 0.7)',
                  }}
                >
                  {t('roadmap.' + option.descKey)}
                </Typography>
              </CardContent>
            </SelectableCard>
          ))}
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        {onBack && (
          <Button onClick={onBack} sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
            {t('roadmap.back')}
          </Button>
        )}
        <Button onClick={onClose} sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
          {t('roadmap.cancel')}
        </Button>
        <Button
          onClick={handleContinue}
          variant="contained"
          disabled={!selectedHorizon}
          sx={{ ml: 1 }}
        >
          {t('roadmap.continue')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default TimeProjectionPopup

